import { render } from "./VueClassicModalPopUp.vue?vue&type=template&id=56f96eb0&scoped=true&ts=true"
import script from "./VueClassicModalPopUp.vue?vue&type=script&lang=ts"
export * from "./VueClassicModalPopUp.vue?vue&type=script&lang=ts"

import "./VueClassicModalPopUp.vue?vue&type=style&index=0&id=56f96eb0&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f96eb0"]])

export default __exports__